// extracted by mini-css-extract-plugin
module.exports = {"faxDetails":"styles_faxDetails__KYC3_","detailsBorder":"styles_detailsBorder__2Z1WV"};